import styled from 'styled-components';
import { BodySmallMedium } from '@src/fonts/typography/Typography';
import { LayoutColors } from '@src/core/theme';

const ErrorWarning = styled.div<{ variant?: 'error' | 'warning' }>`
  ${BodySmallMedium};
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 4px;
  background-color: ${({ variant = 'error' }) =>
    variant === 'warning' ? LayoutColors.warningLight : LayoutColors.errorLight};
  color: ${({ variant = 'error' }) => (variant === 'warning' ? '#BB8000' : LayoutColors.errorDark)};
`;
1;

export default ErrorWarning;
